import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ProvisioningRepository } from '@efficiently/client-api-provisioning';

import { ProvisioningGqlRepository } from './repositories/provisioning-gql.repository';

export function provideProvisioningDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: ProvisioningRepository, useClass: ProvisioningGqlRepository }]);
}
